import { EntityList } from "./core/entity-list";
import { ChatMessage } from "./chat-messages/chat-message.model";
export class ChatMessageList extends EntityList {
    constructor(dtos = []) {
        super(dtos, ChatMessage);
    }
}
